import {db} from '@/main'

export default {    
    async getCompanyInfo(companyId){
        let company = []
        await db.collection('empresas').doc(companyId).get()
        .then(async(snapshot) => {
            company = snapshot.data()
            company.id = snapshot.id
        })
        return company
    },
    async getDataInfo(companyId){
        let companyInfo = {
            colecoes : '',
            categorias: '',
            produtos: '',

        }
        let company = db.collection('empresas').doc(companyId)

        await db.collection('colecoes').where('empresa', '==', company).get()
        .then(async(col) => {           
            companyInfo.colecoes = col.docs.map(doc => {let a = doc.data(); a.id = doc.id; return a});
        }).catch(function (error) {
            companyInfo.colecoes = ''
            console.error("Error get customer: ", error);
        });
                

        await db.collection('categorias').where('empresa', '==', company).get()
        .then(async (cat) => {
            companyInfo.categorias = cat.docs.map(doc => {let a = doc.data(); a.id = doc.id; return a});
        }).catch(function (error) {
            companyInfo.categorias = ''
            console.error(" Error get lead: ", error);
        });

        await db.collection('produtos').where('empresa', '==', company).get()
        .then(async (pro) => {
            companyInfo.produtos = pro.docs.map(doc =>  {let a = doc.data(); a.id = doc.id; return a});
        }).catch(function (error) {
            companyInfo.produtos = ''
            console.error("Error get csm: ", error);
        });     
        // console.log("company", companyInfo)
        return companyInfo
    }   
}